/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Fisify API
 * OpenAPI spec version: 1.0.0
 */

export type Material = typeof Material[keyof typeof Material];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Material = {
  CHAIR: 'CHAIR',
  TOWEL: 'TOWEL',
  THERABAND: 'THERABAND',
  LONG_ROLLER: 'LONG_ROLLER',
  FOAMROLLER: 'FOAMROLLER',
  FITBALL: 'FITBALL',
  BALL: 'BALL',
  DUMBBELLS: 'DUMBBELLS',
  CREAM: 'CREAM',
  TABLE: 'TABLE',
  COINS: 'COINS',
  STEP: 'STEP',
  SMALL_BALL: 'SMALL_BALL',
  PAPER: 'PAPER',
  CUSHION: 'CUSHION',
  BOTTLE: 'BOTTLE',
  PIKE: 'PIKE',
  GAMEBALL: 'GAMEBALL',
  SLIDER: 'SLIDER',
} as const;
